// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2nsmb","label":"CategoryService_label__33me_","location":"CategoryService_location__1DpjY"};